import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import type { SkeletonToolbarProps } from '@atlassian/platform-floating-toolbar';
// TODO: import ToolbarSkeleton from @atlassian/platform-floating-toolbar when cleaning up migrate_to_platform_bulk_toolbar
import { ToolbarSkeleton } from '../../../common/migration.tsx';
import { messages as changeStatusMessages } from '../use-status-action/messages.tsx';
import { messages as editButtonMessages } from '../use-edit-action/messages.tsx';
import { messages as deleteButtonMessages } from '../bulk-delete/messages.tsx';
import { messages as watchOptionsButtonMessages } from '../use-watch-action/messages.tsx';

export const BulkOperationsToolbarSkeleton = ({
	hasSelectAllButton,
	buttons,
}: SkeletonToolbarProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const allButtons: SkeletonToolbarProps['buttons'] = [
		{
			text: formatMessage(editButtonMessages.editButton),
			hasIcon: true,
		},
		{
			text: formatMessage(changeStatusMessages.changeStatus),
			hasIcon: true,
		},
		{
			text: formatMessage(deleteButtonMessages.deleteButton),
			hasIcon: true,
		},
		{
			text: formatMessage(watchOptionsButtonMessages.watchOptions),
			hasIcon: true,
		},
		...buttons,
	];

	return <ToolbarSkeleton hasSelectAllButton={hasSelectAllButton} buttons={allButtons} />;
};
